import React from 'react';
import { Image, Text, View } from 'react-native';
import { getImageByKey, getServiceActionBarImageByKey } from '../../utils/ImagesManagementUtils';
import {
  Android, company_logo, getSubCategoryId, icon_action_bar,
} from '../../utils/DictionaryManagementUtils';
import { textPrimary_7_0 } from '../SimulatorsComponents/AuxiliaryComponent/TextComponent/TextStyle';

//= ========================================================================

const ActionBarServicesLayout = ({
  globJSON, simPlatform,
}) => {
  const { services } = globJSON.configurations;
  const img_stub = getImageByKey(services.menu.hotkey_qab, company_logo);
  const myStyles = {
    serviceIconContainer: {
      paddingStart: 42,
      paddingTop: 8,
      gap: 3,
      display: 'flex',
      flexDirection: 'row',
    },
    companyLogo: {
      height: simPlatform === Android ? 30 : 26,
      width: simPlatform === Android ? 30 : 26,
      marginLeft: simPlatform === Android ? 8 : 7,
      marginTop: simPlatform === Android ? 106 : 86.3,
    },
    serviceIcon: {
      height: simPlatform === Android ? 30 : 26,
      width: simPlatform === Android ? 36.92 : 32,
      borderRadius: 9,
      backgroundColor: '#ffffff',
      marginTop: simPlatform === Android ? -40 : -34,
      marginLeft: simPlatform === Android && 8,
      alignSelf: 'center',
    },
    serviceName: {
      marginTop: 2,
      textAlign: 'center',
      width: 47,
      height: 14,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      wordWrap: 'break-word',
      marginLeft: simPlatform === Android && 8,
    },
  };

  return (
    <View>
      <Image
        fadeDuration={0}
        style={myStyles.companyLogo}
        source={img_stub}
      />
      <View style={myStyles.serviceIconContainer}>
        {services.screens_ordering
          .filter((serviceKey) => services[serviceKey].selected)
          .map((serviceKey) => (
            <View>
              <Image
                fadeDuration={0}
                style={myStyles.serviceIcon}
                source={getServiceActionBarImageByKey(globJSON, getSubCategoryId(services[serviceKey]),
                  services[serviceKey].sub_category, icon_action_bar)}
              />
              <Text
                style={[textPrimary_7_0(globJSON, simPlatform), myStyles.serviceName]}
              >
                {services[serviceKey].name}
              </Text>
            </View>
          ))}
      </View>
    </View>
  );
};
export default ActionBarServicesLayout;
